import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELFORMBLOCK_LEGACY_FIELD_ORDER = [
  "title"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelFormBlockDescriptor: _generatedCartFunnelFormBlockDescriptor,
  cartFunnelFormBlockBlocDefinition,
  cartFunnelFormBlockDashboardLayout,
  cartFunnelFormBlockConfig,
  cartFunnelFormBlockResolveConfig,
  cartFunnelFormBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / Form",
    componentType: 'CartFunnelFormBlockComponent',
    category: 'cart',
    description: "Cart funnel / Form.",
    keywords: [],
    allowed_in: ["CartFunnelPage"],
    sharedFields: {}
,
    slots: [
      {
        key: 'items',
        name: "pages.blocks.cart-funnel-form.items.label",
        accept: 'explicitOnly',
        allowedTypes: ["CartFunnelItemBlock", "CartFunnelRadioItemBlock", "CartFunnelTextItemBlock", "CartFunnelCheckboxItemBlock", "CartFunnelOnBehalfUserEmailItemBlock", "CartFunnelOnBehalfUserPhoneItemBlock", "CartFunnelOnBehalfUserFullNameItemBlock", "CartFunnelOnBehalfUserOptinItemBlock", "CartFunnelSelectBlock", "CartFunnelSeatCountItemBlock", "CartFunnelMinimumAgeItemBlock", "TextBlock", "FrameBlock", "ImageFullWidthBlock", "ImageVariableWidthBlock", "ImageAndTextBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-form.title.label",
        help: "pages.blocks.cart-funnel-form.title.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-form.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-form.fieldset.form.label",
            fields: ["title", "items"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelFormBlockDescriptor(): IBlockDescriptor;
export function cartFunnelFormBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelFormBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelFormBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelFormBlockDescriptor, cartFunnelFormBlockProperties, fieldOrder);
}

export {
  cartFunnelFormBlockBlocDefinition,
  cartFunnelFormBlockDashboardLayout,
  cartFunnelFormBlockProperties,
  cartFunnelFormBlockConfig,
  cartFunnelFormBlockResolveConfig,
};

export type CartFunnelFormBlockConfig = typeof cartFunnelFormBlockConfig;
